module.exports = __webpack_public_path__ + "static/Ni2-4c32d4867e8e0439acc56e5f002b9bfa.png";